<template>
  <div class="container pt-4">
    <h1 style="text-align: center">Ceny ubytování</h1>
    <div class="row justify-content-lg-center pt-4">
      <div class="col-lg-2 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">Dospělí (1-2 noci)</h4>
            <i class="fa fa-user fa-4x"></i>
            <p class="card-text">
              <span style="font-weight: bold">700 Kč</span><br/>osoba/den
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-2 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">Dospělí (3 noci)</h4>
            <i class="fa fa-user fa-4x"></i>
            <p class="card-text">
              <span style="font-weight: bold">650 Kč</span><br/>osoba/den
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-2 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">Dospělí (4+ nocí)</h4>
            <i class="fa fa-user fa-4x"></i>
            <p class="card-text">
              <span style="font-weight: bold">600 Kč</span><br/>osoba/den
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-2 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">Děti do 6 let</h4>
            <i class="fa fa-child fa-4x"></i>
            <p class="card-text">
              <span style="font-weight: bold">400 Kč</span><br/>osoba/den
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-2 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">Děti do 2 let</h4>
            <i class="fa fa-baby fa-4x"></i>
            <p class="card-text">
              <span>zdarma</span>
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-3 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">Zvířata</h4>
            <i class="fa fa-ban fa-3x"></i><br>
            <i class="fa fa-paw fa-3x"></i>
            <p class="card-text">
              <span>pobyt domácích zvířat neumožňujeme</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-lg-center pt-4">
      <div class="col-lg-4 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">Poplatky</h4>
            <p class="card-text">
              <i class="fa fa-money-bill"></i>
              <span style="font-weight: bold; margin-left: 5px">Poplatek obci: 30 Kč</span> (osoba/den)
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "pricing",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-body {
  text-align:center;
}
</style>
